import * as ng from 'angular';
import { PanelHeaderData } from '../../../atomic-components/molecules/panels/panel-header/panel-header';
import { DisableFilter } from '../../../atomic-components/organisms/overview/overview';

export class TemplateWebhostingJobOverviewController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PanelHeaderData;
    public overviewServiceData;
    public expertView: boolean;
    public disableFilter: DisableFilter;

    public overviewModel;
    private simpleFilter;
    private extendedFilters;
    private overviewUiSettings;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit() {
        this.expertView = true; // only expertview on job overviews
        this.disableFilter = {
            fancyFilter: false,
            searchFilter: false
        };

        this.pageHeaderData = {
            backwardLink: 'webhosting.dashboard',
            backwardText: this.$translate.instant('TR_140119-285630_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: null,
            panelIcon: 'server',
            panelTitle: this.$translate.instant('STATE.WEBHOSTING.JOB.PAGE-TITLE')
        };

        this.overviewServiceData = {
            extendedFilters: this.extendedFilters,
            fancyFilterExpand: this.expertView,
            overviewService: 'webhostingJob',
            overviewUiSettings: this.overviewUiSettings,
            simpleFilter: this.simpleFilter,
            sort: {
                field: 'jobAddDate',
                order: 'DESC'
            }
        };
    }
}

export class TemplateWebhostingJobOverviewComponent implements ng.IComponentOptions {
    public bindings = {
        extendedFilters: '<',
        overviewModel: '<',
        overviewUiSettings: '<',
        simpleFilter: '<'
    };
    public controller = TemplateWebhostingJobOverviewController;
    public controllerAs = 'TemplateWebhostingJobOverviewCtrl';
    public template = require('./webhosting-job-overview-template.html');
}
